export default __webpack_public_path__ + "static/media/DSC_9098.22422af5.jpg";